export default __webpack_public_path__ + "static/media/closechat.5b9ecb19.wav";